import { createAsyncThunk } from "@reduxjs/toolkit";

import LocalStorage from "../../../../Services/Storage/LocalStorage";
import StorageModel from "../../../../Models/StorageModel";
import HttpsClient from "../../../../Services/HttpsClient";
import ApiHelper from "../../../../Services/ApiHelper";
import Cache from "../../../../Services/Cache";
import UserProfileAPI, { UserProfileApiUrls } from "../API/UserProfileAPI";

const storage = new LocalStorage();
const storageModel = new StorageModel(storage);
const cache = new Cache(storageModel);

const httpsClient = new HttpsClient();
const apiHelper = new ApiHelper(httpsClient);
const userProfileAPI = new UserProfileAPI(apiHelper, cache);

export const getCandidatesByUserId = createAsyncThunk(
  UserProfileApiUrls.getCandidatesByUserId,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    return await userProfileAPI.getCandidatesByUserId(payload, token);
  }
);
